import React from 'react';
import './Topsection.css'
import jakaria from '../image/jakaria.jpeg'
const Topsection = () => {
    return (
        <div className='topsection-container '>
           
            <div className=' row d-flex flex-wrap '>
                <div className='col-md-6 mb-5 mt-5'>
                    <img src={jakaria} alt="" className='img-fluid free-img' />
                </div>
                <div className='col-md-6 mt-5 text-center '>
               <p className="p-2">
                  Hi, I am Md Jakaria. I am a student of Computer Science And Engineering at Imperial college of Engineering. You Can get here Engineering Study Materials(ICE-CSE). Subscribe My youtube channel for learning more.Contact with me for more information.
                   
               </p>
               <h4 className="text-center">Social Links</h4>
               <hr/>
               <div className="text-center">
                   <a target="_blank" href="https://www.facebook.com/samim.jakaria.5/"> FaceBook</a> <br/>
                   <a target="_blank" href="https://www.instagram.com/md_jakaria61/"> Instagram</a> <br/>
                   <a target="_blank" href="https://www.linkedin.com/in/md-jakaria-8b04a3216/"> LinkedIn</a> <br/>
                   <a target="_blank" href="https://github.com/jakaria61"> GitHub</a> <br/>
                   <a target="_blank" href="#"> Youtube</a> <br/>
                   <p>Phone: +8801789714761</p>
                   <p>Email: bdjakaria629@gmail.com</p>
                   

               </div>

                </div>
            </div>
        </div>
    );
};

export default Topsection;